import { Component, OnInit, ViewChild } from '@angular/core';
import { ChangeDataConst } from 'src/app/core/constants/change-data.const';
import { CommonService } from 'src/app/core/services/common.service';
import { RecommendedStockingLocationDto } from 'src/app/features/setup/models/stocking-location.model.ts/stocking-location.model';
import { of, switchMap } from 'rxjs';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { AutoCompleteComponent } from '@progress/kendo-angular-dropdowns';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialNumberJdeService } from '../services/material-number-jde.service';
import { NewActionInputParam } from '../models/common/new-action-input-param.model';
import { RequestLineService } from '../services/request-line.service';
import { InventoryLevelUpdateDto, InventoryLevelUpdateGridDataDto } from '../models/change-sar/inventory-level-update.model';
import { InventoryLevelUpdateService } from '../services/inventory-level-update.service';
import { AddNewItemConstant } from 'src/app/core/constants/add-new-item.constant';
import { LineAssignmentDto } from '../models/common/line-assignment.model';
import { ReAssignItemComponent } from '../components/approval-management/re-assign-item/re-assign-item.component';
import { requestStateEnum } from 'src/app/core/constants/sar-dashboard.const';
import { SharedConst } from 'src/app/core/constants/shared.constant';

@Component({
    selector: 'app-inventory-level-update-add-new-item',
    templateUrl: './inventory-level-update-add-new-item.component.html',
    styleUrls: ['./inventory-level-update-add-new-item.component.scss'],
    standalone: false
})
export class InventoryLevelUpdateAddNewItemComponent implements OnInit {
  newActionInputParam: NewActionInputParam = {};
  gridData: InventoryLevelUpdateGridDataDto[] = [];
  inventoryLevelUpdateDataErrors: InventoryLevelUpdateGridDataDto[] = [];
  materialData: string[] = [];
  itemDescription: string = '';
  recommendedStockingLocations: RecommendedStockingLocationDto[] = [];
  lineAssignment?: LineAssignmentDto = new LineAssignmentDto();
  selectedUnitPrice: string;
  lineItem: string = '';
  unitPrices: string[] = [];
  matValidError: boolean;
  materialNumValidationError: boolean;
  disabledTypes: boolean;
  prevSelectedMaterial: any;
  selectedMaterial: string = '';
  requestorNotesMaxLength: number = 1000;
  requestorNotesCharachtersCount: number = 0;
  isMaterialNumberSelected: boolean = false;
  annualUsageForecast: number;
  stockCount: number = 0;
  totalValue: number = 0;
  changeInValue: number = 0;
  unitPrice: number;
  requesterNotes: string = '';
  assetName: string = '';
  id: number;
  buId: number = 32;
  matError: boolean;
  lineItemStatus: string = '';
  annualUsageForecastError: boolean = false;
  isEditLineAction: boolean = false;
  isGridError: boolean = false;
  isAnyRequestLinesWithMinMax: boolean = false;
  errorMessageInvalidMaterialNumberWithAsset: string = "For given Material Number and Asset there are no stocking location found. Please select another Material Number or Asset";
  errorMessageAlreadyExistingMaterialNumberInRequestLine: string = "Entered Material Number already exists in Request Line. Please select another Material Number";
  errorMesageInventoryLevelUpdateRow: string = "For given Recommended Stocking Location there are no records found. Please select another Recommended Stocking Location";
  selectedStockingLocations: RecommendedStockingLocationDto[] = [];
  @ViewChild("autocomplete", { static: false })
  public autocomplete!: AutoCompleteComponent;

  constructor(private commonService: CommonService,
    private materialJdeService: MaterialNumberJdeService,
    public router: Router,
    private route: ActivatedRoute,
    private requestLineService: RequestLineService,
    private inventoryLevelUpdateService: InventoryLevelUpdateService,
    private dialogService: DialogService,
  ) {
    const stateData: any = this.router.currentNavigation()?.extras.state;
    if (!this.commonService.isNullOrEmptyOrUndefined(stateData)) {
      this.newActionInputParam.isNew = stateData['isNew'];
      this.newActionInputParam.requestId = stateData['requestId'];
      this.newActionInputParam.requestNumber = stateData['requestNumber'];
      this.newActionInputParam.actionNumber = stateData['actionNumber'];
      this.newActionInputParam.changeType = stateData['changeType'];
      this.newActionInputParam.requestIssueId = stateData['requestIssueId'];
      this.newActionInputParam.assetName = stateData['assetName'];
      this.newActionInputParam.requestStateId = stateData['requestStateId'];
      this.id = stateData['id'];
      this.assetName = stateData['assetName'];
      this.selectedMaterial = String(stateData['materialNumber']);
      this.selectedUnitPrice = stateData['unitPrice'];
      this.itemDescription = stateData['itemDescription'];
      this.lineItemStatus = stateData['status'];
      this.annualUsageForecast = stateData['annualUsageForecast'];
      this.stockCount = stateData['stockCount'];
      this.totalValue = stateData['totalValue'];
      this.changeInValue = stateData['changeInValue'];
      this.requesterNotes = stateData['requesterNotes'] ?? '';
      this.isEditLineAction = stateData['isEditLineAction'];
      this.isAnyRequestLinesWithMinMax = stateData['isAnyRequestLinesWithMinMax'];
      this.gridData = stateData['inventoryLevelUpdateGridData'] ?? [];
      if (this.gridData !== undefined && this.gridData.length > 0) {
        this.selectedStockingLocations = this.gridData.map(item => {
          return {
            code: item.code,
            description: item.description,
          };
        });
      }

      sessionStorage.setItem('inventory-level-update-add-new-item', JSON.stringify(stateData));
    }
    else {
      let sessionState = JSON.parse(sessionStorage.getItem('inventory-level-update-add-new-item')!);
      if (!this.commonService.isEmptyOrUndefined(sessionState)) {
        this.newActionInputParam.isNew = sessionState.isNew;
        this.newActionInputParam.requestId = sessionState.requestId;
        this.newActionInputParam.requestNumber = sessionState.requestNumber;
        this.newActionInputParam.requestIssueId = sessionState.requestIssueId;
        this.newActionInputParam.changeType = sessionState.changeType;
        this.newActionInputParam.actionNumber = sessionState.actionNumber;
        this.newActionInputParam.assetName = sessionState.assetName;
      }
    }
  }

  ngOnInit(): void {
    if (this.selectedMaterial !== undefined && this.selectedMaterial !== '' && !this.newActionInputParam.isNew) {
      this.materialData.push(this.selectedMaterial);
      this.isMaterialNumberSelected = true;
      this.materialChange(this.selectedMaterial);
    } else {
      this.selectedMaterial = '';
      this.isMaterialNumberSelected = false;
    }
  }

  materialChange(value: any) {
    let indexOfSelectedMaterial = this.materialData.findIndex(x => x === value.toString());
    let isMaterialNumberInLine = false;

    if (indexOfSelectedMaterial === -1) {
      this.matValidError = true;
      this.materialNumValidationError = false;
      this.commonService.showNotificationMessage(ChangeDataConst.globalErrorMessage, 'error', 'right')
      return false;
    }

    else {
      this.matValidError = false;
      this.materialNumValidationError = false;
      if (!this.commonService.isNullOrEmptyOrUndefined(value)) {
        this.matError = false;
      }

      this.requestLineService.getMatchingStockingLocationsInRequestLine(this.newActionInputParam.requestId!, value)
        .subscribe(res => {
          if (res == null || res.length === 0) {
            this.isMaterialNumberSelected = false;
            this.commonService.showNotificationMessage(this.errorMessageInvalidMaterialNumberWithAsset, 'error', 'center');
            return;
          }

          else {
            this.requestLineService
              .verifyIfMaterialNumberInRequestLine(this.newActionInputParam.requestId!, this.newActionInputParam.requestIssueId!, value)
              .subscribe(response => {
                isMaterialNumberInLine = response;

                if (isMaterialNumberInLine && !this.isEditLineAction) {
                  this.isMaterialNumberSelected = false;
                  this.commonService.showNotificationMessage(this.errorMessageAlreadyExistingMaterialNumberInRequestLine, 'error', 'center');
                  return;
                }
                else {
                  this.recommendedStockingLocations = res;
                  this.getItemData(res.map(x => x.code!));
                }
              });
          }
        });
    }
  }

  getItemData(codes: string[]) {
    this.unitPrices = [];
    this.materialJdeService
      .getInventoryLevelUpdateItemData(this.selectedMaterial.toString(), codes)
      .subscribe(res => {
        if (res == null) {
          this.isMaterialNumberSelected = false;
          this.commonService.showNotificationMessage(this.errorMessageInvalidMaterialNumberWithAsset, 'error', 'center');
          return;
        }
        else {
          this.itemDescription = res.description;
          this.unitPrice = res.unitPrice
          this.setUnitPrices(this.unitPrice);
          this.isMaterialNumberSelected = true;
        }
      })
  }

  setUnitPrices(unitPrice: number) {
    for (const location of this.recommendedStockingLocations) {
      const item = `${location.code} - ${unitPrice}`;
      if (!this.newActionInputParam.isNew && unitPrice === Number(this.selectedUnitPrice)) {
        this.selectedUnitPrice = item;
      }
      this.unitPrices.push(item);
    }
  }

  selectLocation(input: RecommendedStockingLocationDto[]): void {
    const newestSelectedStockingLocation = input[input.length - 1];
    if (!newestSelectedStockingLocation) {
      return;
    }

    const lastInputCode = input[input.length - 1].code;
    if (this.gridData !== undefined && this.gridData.some(item => item.code === lastInputCode)) {
      return;
    }

    this.materialJdeService.getInventoryLevelUpdateRowData(this.selectedMaterial.toString(), newestSelectedStockingLocation.code!)
      .subscribe(res => {

        if (res == null) {
          this.commonService.showNotificationMessage(this.errorMesageInventoryLevelUpdateRow, 'error', 'center');
          this.recommendedStockingLocations = this.recommendedStockingLocations.filter(location => location.code !== newestSelectedStockingLocation.code);
          this.selectedStockingLocations = this.selectedStockingLocations.filter(location => location.code !== newestSelectedStockingLocation.code);
          return;
        }

        const item: InventoryLevelUpdateGridDataDto = {
          id: 0,
          code: newestSelectedStockingLocation.code!,
          description: res.description,
          existingMinimum: res.existingMinimum,
          existingMaximum: res.existingMaximum,
          recommendedMinimum: 0,
          recommendedMaximum: 0,
          estimatedStockHoldingValue: 0
        };
        this.gridData.push(item);
      });
  }

  removeLocation(input: RecommendedStockingLocationDto): void {
    let matchingItems = this.gridData.filter(item => item.code === input.code);
    if (matchingItems.length !== 0) {
      matchingItems.forEach(item => {
        const index = this.gridData.indexOf(item);
        if (index !== -1) {
          this.gridData.splice(index, 1);
        }
      });
    }
    this.calculateValues();
  }

  filter(value: any) {
    if (value.toString().length >= 3) {
      this.materialJdeService.getMaterialNumbers(value.toString()).pipe(
        switchMap(result => {
          return of(result);
        })
      ).subscribe(result => {
        this.materialData = result;
        if (this.materialData.length === 1) {
          this.selectedMaterial = this.materialData[0];
          this.materialChange(this.selectedMaterial);
        }
      });
    } else {
      this.isMaterialNumberSelected = false;
      this.autocomplete.toggle(false);
    }
  }

  public unitPriceSelectionChange(value: any): void { }

  isMinMaxError(dataItem: InventoryLevelUpdateGridDataDto): boolean {

    // Bypass validation if stocking location is set to 140061010A and Asset is WA Oil
    if (dataItem.code === AddNewItemConstant.stockingLocationForNoMaxValidation &&
      this.newActionInputParam.assetName === AddNewItemConstant.assetForNoMaxValidation) {
      return false;
    }

    let isError = (dataItem.recommendedMinimum ?? 0) >= (dataItem.recommendedMaximum ?? 0);
    if (dataItem.recommendedMinimum == 0 && dataItem.recommendedMaximum == 0) {
      isError = false;
    }
    if (isError) {
      this.inventoryLevelUpdateDataErrors.push(dataItem);
      this.isGridError = isError;
    }
    else {
      const index = this.inventoryLevelUpdateDataErrors.indexOf(dataItem);
      this.inventoryLevelUpdateDataErrors.splice(index, 1);
      this.isGridError = false;
    }

    return this.isGridError;
  }

  updateValue(value: any) {
    if (value == null || value == undefined || value < 0) {
      return 0
    }
    return value;
  }

  onValueChange(newValue: number, dataItem: any): void {
    dataItem.recommendedMaximum = newValue;
    this.setEstimatedStockHoldingValue(dataItem);
    this.calculateValues();
  }

  calculateValues(): void {
    this.setStockCountValue();
    this.setTotalValue();
    this.setChangeInValue();
  }

  setEstimatedStockHoldingValue(dataItem: any): void {
    const index = this.gridData.findIndex(item => item === dataItem);
    if (index !== -1) {
      this.gridData[index].estimatedStockHoldingValue = (dataItem.recommendedMaximum ?? 0) * this.unitPrice;
    }
  }

  setStockCountValue(): void {
    this.stockCount = this.gridData.reduce((sum, dataItem) => sum + (dataItem.recommendedMaximum ?? 0), 0);
  }

  setTotalValue(): void {
    this.totalValue = this.stockCount * this.unitPrice;
  }

  setChangeInValue(): void {
    let sumRecommendedMaximum = this.gridData.reduce((sum, dataItem) => sum + (dataItem.recommendedMaximum ?? 0), 0);
    let sumExistingMaximum = this.gridData.reduce((sum, dataItem) => sum + (dataItem.existingMaximum ?? 0), 0);
    this.changeInValue = (sumRecommendedMaximum * this.unitPrice) - (sumExistingMaximum * this.unitPrice);
  }

  public requestorNotesValueChange(value: any): void {
    this.requestorNotesCharachtersCount = value.length;
  }

  public navToBack(): void {
    this.router.navigate(['./' + 'newaction'], {
      state: {
        isNew: this.newActionInputParam.isNew,
        requestId: this.newActionInputParam.requestId,
        requestIssueId: this.newActionInputParam.requestIssueId,
        changeType: 'Inventory Level Update',
        requestNumber: this.newActionInputParam.requestNumber,
        actionNumber: this.newActionInputParam.actionNumber,
        assetName: this.newActionInputParam.assetName
      }, relativeTo: this.route.parent
    });
  }

  public validate(): boolean {

    if (this.gridData.every(x => x.recommendedMinimum === 0)
      && this.gridData.every(x => x.recommendedMaximum === 0)) {
      if (this.commonService.isNullOrEmptyOrUndefinedOnly(this.annualUsageForecast)) {
        this.commonService.showNotificationMessage('Please fill the highlighted field', 'error', 'right')
        this.annualUsageForecastError = true;
        return false;
      }
      else {
        this.annualUsageForecastError = false;
      }
    }
    else {
      if (this.commonService.isNullOrEmptyOrUndefined(this.annualUsageForecast)) {
        this.commonService.showNotificationMessage('Please fill the highlighted field', 'error', 'right')
        this.annualUsageForecastError = true;
        return false;
      }
      else {
        this.annualUsageForecastError = false;
      }
    }

    if (this.isGridError) {
      this.commonService.showNotificationMessage('Please fill the highlighted field', 'error', 'right')
      return false;
    }

    return true;
  }

  public AddAndUpdate(): void {
    if (!this.validate()) {
      return;
    }
    const inventoryLevelUpdateIssueTypeId: number = 6;
    let item: InventoryLevelUpdateDto = {
      createdBy: this.commonService.getUserEmailId(),
      lineNumber: 0,
      id: 0,
      requestId: this.newActionInputParam.requestId!,
      requestIssueTypeId: inventoryLevelUpdateIssueTypeId,
      requestIssueId: this.commonService.isNullOrEmptyOrUndefined(this.newActionInputParam.requestIssueId)
        ? 0 : this.newActionInputParam.requestIssueId,
      materialNumber: Number(this.selectedMaterial),
      itemDescription: this.itemDescription,
      asset: this.newActionInputParam.assetName!,
      requesterNotes: this.requesterNotes,
      annualUsageForecast: this.annualUsageForecast,
      stockCount: this.stockCount,
      totalValue: this.totalValue,
      changeInValue: this.changeInValue,
      status: 'Change Sar',
      modifiedBy: '',
      unitPrice: this.unitPrice,
      assignedGroup: 0,
      assignedUser: 0,
      inventoryLevelUpdateGridData: this.gridData
    }

    if (this.isEditLineAction !== undefined && this.isEditLineAction) {
      item.id = this.id;
      if (this.lineItemStatus === 'Rejected') {
        this.openreAssignment(item);
      } else {
        this.inventoryLevelUpdateService.updateItem(item).subscribe(res => {
          this.commonService.showNotificationMessage('Request line succesfully updated', 'success', 'right')
          this.router.navigate(['./' + 'newaction'], {
            state: {
              isNew: false,
              requestId: res.requestId,
              requestLineId: res.requestLineId,
              requestIssueId: res.requestIssueId,
              changeType: 'Inventory Level Update',
              requestNumber: this.newActionInputParam.requestNumber,
              actionNumber: this.newActionInputParam.actionNumber,
              assetName: this.newActionInputParam.assetName
            }, relativeTo: this.route.parent
          });
        });
      }
    }
    else {
      this.inventoryLevelUpdateService.addNewItem(item).subscribe(res => {
        this.commonService.showNotificationMessage('Request line succesfully created', 'success', 'right')
        this.router.navigate(['./' + 'newaction'], {
          state: {
            isNew: false,
            requestId: res.requestId,
            requestLineId: res.requestLineId,
            requestIssueId: res.requestIssueId,
            changeType: 'Inventory Level Update',
            requestNumber: this.newActionInputParam.requestNumber,
            actionNumber: this.newActionInputParam.actionNumber,
            assetName: this.newActionInputParam.assetName
          }, relativeTo: this.route.parent
        });
      });
    }
  }

  openreAssignment(item: any) {
    let grouptype = 1
    if (this.isAnyRequestLinesWithMinMax || (this.gridData !== undefined && this.gridData.length > 0)) {
      grouptype = 2
    }

    const dialog: DialogRef = this.dialogService.open({
      content: ReAssignItemComponent
    });
    const inc = dialog.content.instance as ReAssignItemComponent;
    inc.requestIssueId = this.newActionInputParam.requestIssueId!;
    inc.lineItemId = this.id!;
    inc.groupType = grouptype;

    inc.listItems = []
    dialog.result.subscribe((r: any) => {
      if (this.commonService.isNullOrEmpty(r.actionType) || r.actionType === 'Close') {
        return false;
      }
      // Update line item
      this.inventoryLevelUpdateService.updateItem(item).subscribe(res => {
        this.lineAssignment = r.lineItemDtail as LineAssignmentDto;
        this.lineAssignment.requestId = this.newActionInputParam.requestId;
        this.lineAssignment.requestIssueId = this.newActionInputParam.requestIssueId;
        this.lineAssignment.requestIssueTypeId = 6;
        this.lineAssignment.businessUnitId = this.buId;
        this.lineAssignment.state = this.isAnyRequestLinesWithMinMax ? requestStateEnum.pendingStockingApproval : requestStateEnum.pendingMMD;
        this.lineAssignment.isGeneralComment = false;
        this.lineAssignment.comment = '';
        this.lineAssignment.createdBy = this.commonService.getUserEmailId();
        this.lineAssignment.modifiedBy = this.commonService.getUserEmailId();
        this.lineAssignment.attachments = [];
        this.lineAssignment.requestLineIds = []
        this.lineAssignment.requestLineIds.push(this.id!);
        this.saveAndAssign();
      });
    });
  }

  saveAndAssign() {
    if (this.commonService.isNullOrEmptyOrUndefined(this.lineAssignment!.assignedGroupId!) && !this.lineAssignment?.isMixedValues) {
      this.commonService.showNotificationMessage(SharedConst.validationMessage, 'error', 'center');
    }
    else {
      let userId: any = this.lineAssignment!.assignedUserId!;
      if (this.commonService.isNullOrEmptyOrUndefined(this.lineAssignment!.assignedUserId!.toString())) {
        userId = null;
      }

      let groupId: any = this.lineAssignment!.assignedGroupId!;
      if (this.commonService.isNullOrEmptyOrUndefined(this.lineAssignment!.assignedGroupId!)) {
        groupId = null;
      }
      const formData = new FormData();
      formData.append('requestId', this.lineAssignment!.requestId!.toString());
      formData.append('requestIssueId', this.lineAssignment!.requestIssueId!.toString());
      formData.append('requestIssueTypeId', this.lineAssignment!.requestIssueTypeId!.toString());
      formData.append('businessUnitId', this.lineAssignment!.businessUnitId!.toString());
      formData.append('assignedGroupId', groupId);
      formData.append('assignedUserId', userId);
      formData.append('state', this.lineAssignment!.state!.toString());
      formData.append('comment', this.lineAssignment!.comment!);
      formData.append('isGeneralComment', this.lineAssignment!.isGeneralComment!.toString());
      formData.append('createdBy', this.lineAssignment!.createdBy!);
      formData.append('modifiedBy', this.lineAssignment!.modifiedBy!);
      for (let id of this.lineAssignment!.requestLineIds!) {
        formData.append('requestLineIds', id.toString());
      }

      this.requestLineService.updateLineAssignmentForRejected(formData).subscribe(response => {
        this.commonService.showNotificationMessage(AddNewItemConstant.updateSuccessMessage, 'success', 'right')
        this.router.navigate(['./' + 'newaction'], {
          state: {
            isNew: true, 
            requestId: this.lineAssignment!.requestId!,
            requestIssueId: this.lineAssignment!.requestIssueId!, 
            changeType: 'Inventory Level Update',
            requestNumber: this.newActionInputParam.requestNumber,
            actionNumber: this.newActionInputParam.actionNumber
          }, relativeTo: this.route.parent
        });
      })
    }
  }
}

